GameView = require "views/base/game"

class MatrixView extends GameView
  template: require("./template")

  events:
    "iostap .selectable": "selectAnswer"
    "iostap .btn-done": "endGame"

  serialize: ->
    d = super
    d.isLong = _.chain(d.metadata.questions)
      .pluck('answers')
      .flatten()
      .pluck('content')
      .map (c) => c or ""
      .sortBy((el) -> el.length)
      .last()
      .value()?.length > 10

    # Ensure 'all the above' is the last row
    allTheAboveRx = /the above/i
    d.metadata.questions = _.map d.metadata.questions, (q) ->
      q.answers = _.shuffle(q.answers)
      allTheAboveAnswer = _.find q.answers, (a) -> allTheAboveRx.test(a.content)
      if allTheAboveAnswer
        q.answers =
          _.without(q.answers, allTheAboveAnswer).concat(allTheAboveAnswer)
      q

    d

  render: ->
    super

    @setEl @findAll(".selectable"), "answers"
    @setEl @findAll(".column"), "columns"

    @onTimerChange(@game.timer)

  show: ->
    super

    @setState("prompt")
    el.classList.remove("active") for el in @getEl "answers"

    @enterGame()

  endGame: ->
    super

    @submit()

  selectAnswer: (e) ->
    return if @currentState.state is "complete"

    target = e.currentTarget
    column = target.dataset.column

    target.classList.add("active")

    for el in @getEl("answers") when el.dataset.column is column
      el.classList.remove("active") if el isnt target

    nbActive =
      el for el in @getEl("answers") when el.classList.contains("active")

    if nbActive.length is @options.metadata.questions.length
      @setState("touched")

  isCorrect: ->
    correctSelected =
      el for el in @getEl("answers") when (
        el.classList.contains("active") and
        el.dataset.correct?
      )

    correctSelected.length is @options.metadata.questions.length

  answerDetails: ->
    questions = @options.metadata.questions or []
    return [] unless questions.length > 0
    details = []

    dictAnswersByColNum = _.groupBy $(".selectable"), (el) ->
      $(el).data("column")

    for q in questions
      colIdx = questions.indexOf(q)
      selectedAnswerEl = _.find dictAnswersByColNum[colIdx], (el) ->
        $(el).hasClass("active")
      selectedAnswer = _.filter q.answers, (a) ->
        cleanedContent = a.content.replace /<[^>]*>/g, ''
        cleanedContent is $(selectedAnswerEl).text()
      questionDetails = question: q.question, answer: selectedAnswer[0]
      details.push questionDetails

    details

module.exports = MatrixView
